<template>
    <div class="good">
        <div class="good_img"><img :src="goods.productPictureUrl" alt=""></div>
        <div class="good_right" :class="{'statusNo': goodLength === goodIndex + 1, 'borderNo': !borderBottom}">
            <h3>{{ goods.skuShowName }}</h3>
            <div class="good_right_bottom" v-if="apply">
                <span>退款：<span class="f30 colFF7A45"><sub>¥ </sub>{{ goods.finalPrice | NumFormat }}</span></span>
                <span><sub>X</sub>{{  goods.quantity || goods.shippingQuantity }}</span>
            </div>
            <div class="good_right_bottom" v-else>
                <span class="colFF7A45"><sub>¥ </sub>{{ goods.finalPrice | NumFormat }}</span><span><sub>X</sub>{{  goods.quantity || goods.shippingQuantity }}</span>
            </div>
            <!-- <div v-if="apply" class="freight">（含运费¥ 10元）</div> -->
            <div v-if="!showStatus" class="good_right_status">{{ !show ? childStatus : '' }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        goods: {
            type: Object,
            default: () => {
                return {}
            }
        },
        // 商品的总数量
        goodLength: {
            type: Number,
            default: 1
        },
        // 最后一个没有下划线
        goodIndex: {
            type: Number,
            default: 0
        },
        show: {
            type: Boolean,
            default: false
        },
        showStatus: {
            type: Boolean,
            default: false
        },
        apply: {
            type: Boolean,
            default: false
        },
        borderBottom: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        childStatus: function () {
            switch (this.goods.orderProductStatus) {
                case 20:
                    return this.goods.shippedQuantity ? '部分发货' : '待发货'
                case 30:
                    return '待收货'
                case 40:
                    return '已完成'
                default:
                    return ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.good {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    &_img {
        width: 184px;
        height: 184px;
        /* margin: 0 24px; */
        margin-right: 24px;
        position: relative;
        display: flex;
        background: #f2f3f5;
        img {
            display: inline-block;
            align-self: center;
            justify-self: center;
            margin: 0 auto;
            object-fit: cover;
        }
    }
    &_right {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        border-bottom: 2px solid #ededf0;
        padding-right: 16px;
        /* align-content: space-between; */
        &.statusNo {
            border-bottom: none;
        }
        &.borderNo {
            border-bottom: none;
        }
        .freight {
            width: 100%;
            font-size: 24px;
            color: #999999;
            padding-left: 74px;
        }
        &.r32 {
            padding-right: 32px;
        }
        h3 {
            width: 100%;
            color: #333;
            font-size: 28px;
            height: 80px;
            line-height: 40px;
            font-weight: 400;
            line-height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
        }
        &_status {
            width: 100%;
            color: #ff7a45;
            font-size: 28px;
            text-align: right;
            padding: 12px 0 32px 0;
        }
        &_bottom {
            flex: 1;
            line-height: 42px;
            display: flex;
            justify-content: space-between;
            position: relative;
            margin-top: 62px;
            span {
                font-size: 30px;
                color: #333333;
                .f30 {
                    font-size: 30px;
                }
                &:first-child {
                    color: #666666;
                }
            }
            sub {
                font-size: 20px;
            }
        }
    }
}
</style>